import type { BetbyEnvironmentConfig } from '@app/core/environment-service';

import { BETBY_BETA_CONFIG } from './betby-beta.config';
import { BETBY_PROD_CONFIG } from './betby-prod.config';

/**
 * Betby stack for the STAGE bundle. One stage build serves SEVERAL stand flavors of the same worker
 * (`wrangler deploy --name fast-new-front-XXXX`), and the backend is resolved from the hostname at
 * runtime (getStageFastGateway): `*.devfast.io` stands run against the DEV backend, whose Betby
 * integration is the BETA stack, while `*.csgofast4.com` stagings and the local stage run against the
 * stage/prod backend wired to the PRODUCTION stack. The widget stack must follow the backend that
 * signs the player token — a mismatch (prod script + dev-signed JWT) kills the dev integration.
 *
 * Host semantics mirror getStageFastGateway exactly, including 'local' winning over 'devfast'
 * (local.devfast.io stage runs the prod gateway → prod stack).
 */
export const resolveStageBetbyConfig = (hostname: string): BetbyEnvironmentConfig => {
  const isLocal = hostname.includes('local');
  const isRemoteDev = hostname.includes('devfast');

  return !isLocal && isRemoteDev ? BETBY_BETA_CONFIG : BETBY_PROD_CONFIG;
};
